import React from 'react';
import { siteConfig } from '../config/siteConfig';
import ScrollingTitle from '../components/ScrollingTitle/ScrollingTitle';
import './Page.css';

const FilmVideoMagazine = () => {
  const { filmVideoMagazine } = siteConfig;

  return (
    <div className="film-video-magazine-page">
      <ScrollingTitle lines={filmVideoMagazine.title.lines} />
      
      <div className="film-video-magazine-content">
        <div className="film-video-magazine-container">
          
          {/* Team Section */}
          <div className="magazine-team-section">
            <h2 className="magazine-section-title">{filmVideoMagazine.team.title}</h2>
            
            <div className="magazine-team-item">
              <h3 className="magazine-team-role">{filmVideoMagazine.team.publisher.title}</h3>
              <p className="magazine-team-name">{filmVideoMagazine.team.publisher.name}</p>
            </div>
            
            <div className="magazine-team-item">
              <h3 className="magazine-team-role">{filmVideoMagazine.team.chiefEditor.title}</h3>
              <p className="magazine-team-name">{filmVideoMagazine.team.chiefEditor.name}</p>
            </div>
            
            <div className="magazine-team-item">
              <h3 className="magazine-team-role">{filmVideoMagazine.team.editorialTeam.title}</h3>
              {filmVideoMagazine.team.editorialTeam.members.map((member, index) => (
                <p key={index} className="magazine-team-name">{member}</p>
              ))}
            </div>
          </div>
          
          {/* Magazine Section */}
          <div className="magazine-covers-section">
            <h2 className="magazine-section-title">{filmVideoMagazine.magazine.title}</h2>
            <h3 className="magazine-subtitle">{filmVideoMagazine.magazine.subtitle}</h3>
            
            <div className="magazine-covers-grid">
              {filmVideoMagazine.magazine.covers.map((cover, index) => (
                <div key={index} className="magazine-cover-item">
                  <a 
                    href={cover.blogUrl} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="magazine-cover-image"
                  >
                    <img src={cover.image.src} alt={cover.image.alt} />
                  </a>
                  <div className="magazine-cover-hashtags">
                    {cover.hashtags.map((hashtag, hashIndex) => (
                      <span key={hashIndex} className="magazine-hashtag">{hashtag}</span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
          
        </div>
      </div>
    </div>
  );
};

export default FilmVideoMagazine; 